import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Provider, useDispatch } from 'react-redux';
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate
} from 'react-router-dom';
import MainDashboard from './pages/mainDashboard';
import { useTypedSelector } from './hooks/useTypeSelector';
import Login from './pages/login';
import { setTheme } from './redux/actions/themeAction';
import { HideNotificationAction } from './redux/actions/notificationAction';
import Notification from './components/Utils/notification';
import { persistor, store } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import moment from 'moment';
import { LogoutAction } from './redux/actions/authAction';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './config/queryClient';

const NotifPopup = () => {
	const notification = useTypedSelector((state) => state.notification);
	const dispatch = useDispatch();

	useEffect(() => {
		if (notification.activated) {
			const timeout = setTimeout(() => {
				dispatch(HideNotificationAction());
			}, 3000);

			return () => clearTimeout(timeout);
		}
	}, [notification]);

	return (
		<div
			className={
				notification.activated
					? 'absolute float-left top-24 left-24 z-50 opacity-100 transition-all duration-500'
					: 'absolute float-left top-24 left-24 z-50 opacity-0 scale-0 transition-all duration-500'
			}
			onClick={() => dispatch(HideNotificationAction())}
		>
			<Notification type={notification.type} message={notification.message} />
		</div>
	);
};
const Routing = () => {
	const { isAuthenticated, accessTokenExpirationDate } = useTypedSelector(
		(state) => state.auth
	);
	const { dark } = useTypedSelector((state) => state.theme);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setTheme(!dark));
		// Check if access token is still valid
		if (moment(accessTokenExpirationDate).isBefore(moment()))
			dispatch(LogoutAction());
	}, []);

	return (
		<Router>
			<Routes>
				<Route
					path="/login"
					element={isAuthenticated ? <Navigate to="/" /> : <Login />}
				/>
				<Route
					path="/home/*"
					element={
						isAuthenticated ? <MainDashboard /> : <Navigate to="/login" />
					}
				/>
				<Route path="/" element={<Navigate to="/home/documents" />} />
			</Routes>
		</Router>
	);
};

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<NotifPopup />

				<QueryClientProvider client={queryClient}>
					<Routing />
				</QueryClientProvider>
			</PersistGate>
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
